import { Box } from "@mui/material"
import { SpecialOffers } from "src/components"
import FooterInfo from "src/components/FooterInfo"
import "../../App.css"
import MainContent from "../MainContent"

const HomePage = () => {
  return (
    <Box className="App" width="100%">
      <SpecialOffers />
      <MainContent />
      <FooterInfo />
    </Box>
  )
}

export default HomePage
